module.exports = __webpack_public_path__ + "static/media/giropay.1188f0f1.svg";